// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-video-player-container-inner[data-v-502719bb]{position:relative}.the-video-player-container-inner .video-js[data-v-502719bb]{position:absolute;top:0;bottom:0;left:0;height:100%;width:100%}.the-video-player-container-inner .video-js .vjs-tech[data-v-502719bb]{pointer-events:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
